import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { MODAL_SIZE, ModalForm } from "components/Modal";
import { css } from "@emotion/react";
import { SIZE, TYPE } from "components/Form";
import { MUTATION_TYPE, useLinks } from "hooks";
import { GENERATE_APPLICATION_PREVIEW_TOKEN } from "graphql/mutations";
import { BrandLogo } from "components/Logo";
import { BRAND_LOGO_VARIANTS } from "constants/brands";
import { Link } from "components/Links";

/**
 * ApplicantPINModalForm
 *
 * @param {String}    applicant
 * @param {Boolean}   show
 * @param {Function}  onCompleted
 */
const ApplicantPINModalForm = ({ show, applicant, onCompleted, ...props }) => {
  const links = useLinks();

  if (!applicant) return null;

  return (
    <ModalForm
      show={show}
      size={MODAL_SIZE.medium}
      title={
        applicant && (
          <FormattedMessage
            id="Missions.Applications.PreviewPage.AuthorizeModal.Title"
            values={{ applicant: applicant?.profile?.firstName, role: applicant?.missionRole?.name }}
          />
        )
      }
      data={FORM_DATA}
      showCancel={false}
      primaryButtonMessageId="Global.Submit"
      mutationType={MUTATION_TYPE.add}
      onCompleted={(data) => onCompleted(data?.generateApplicationPreviewToken)}
      initialValues={{
        pin: "",
        applicantId: applicant?.uuid,
      }}
      mutationData={{
        mutationName: {
          add: GENERATE_APPLICATION_PREVIEW_TOKEN,
        },
      }}
      footer={
        <Link to={links.website}>
          <BrandLogo variant={BRAND_LOGO_VARIANTS.marketing} />
        </Link>
      }
      {...props}
    />
  );
};

const FORM_DATA = [
  {
    style: css`
      width: 100%;
    `,
    items: [
      {
        label: "Enter PIN",
        type: TYPE.input,
        size: SIZE.small,
        properties: {
          name: "pin",
          type: "password",
          inputMode: "numeric",
          pattern: "[0-9]*",
          required: true,
          autoFocus: true,
        },
      },
      {
        type: TYPE.hidden,
        properties: {
          name: "applicantId",
        },
      },
    ],
  },
];

ApplicantPINModalForm.propTypes = {
  applicant: PropTypes.object.isRequired,
  onCompleted: PropTypes.func,
  show: PropTypes.bool,
};

export default ApplicantPINModalForm;
